import { BottomForm } from "../../components"
import { 
    Title,
    ValuesSection,
    MiddleForm, 
    ServicesSection, 
    PortfolioWorksSection, 
    PartnersSection, 
    StatisticSection 
} from "./components/index"

export const MainPage=()=>{

    return(
        <>
            <Title/>
            <ValuesSection/>
            <MiddleForm/>
            <ServicesSection/>
            <PortfolioWorksSection/>
            <PartnersSection/>
            <StatisticSection/>
            <BottomForm/>
        </>
    )
}